export { PlayPauseControls } from "./src/play-pause-controls";
export type { PlayPauseControlsProps } from "./src/play-pause-controls";
